import { useLazyQuery, useMutation, useQuery } from "@apollo/client/react";
import { Box, CircularProgress, Grid } from "@mui/material";
import { useEffect, useMemo, useState } from "react";
import { RenderInputByTypeMobile } from "../../../../components/formGroupGenerator/RenderInputByTypeMobile";

import toast from 'react-hot-toast';
import { obtenerDataImagen } from '../../../../actions/ImagenAction';
import { adaptAllTipoProfesionalEspecialidadArray } from "../../../../adapters/allTipoProfesionalEspecialidadAdapter";
import { ADD_DOCUMENTO_PROFESIONAL, DELETE_DOCUMENTOS_PROFESIONAL } from "../../../../data/graphQL/mutations/Profesionales/documentosProfesional";
import { adaptTipoDocumentoArray, GET_ALL_TIPO_DOCUMENTO } from "../../../../data/graphQL/queries/PacienteProbable/getAllTipoDocumento";
import { GET_ALL_TIPO_PROFESIONAL_ESPECIALIDAD } from "../../../../data/graphQL/queries/PlanCuidado/getTipoProfesionalEspecialidad";
import { GET_DOCUMENTO_PROFESIONAL } from '../../../../data/graphQL/queries/Profesionales/getDocumentoProfesional';
import { adaptFuncionesArray, GET_FUNCIONES } from "../../../../data/graphQL/queries/Profesionales/getFunciones";
import ProveedoresSapField from '../components/TabDatosGenerales/ProveedoresSapField';

export const TabDatosGenerales = ({
  allowedWrite,
  isNew,
  profesionalLoading,
  tipoProfesionales,
  datosGeneralesFormData,
  setDatosGeneralesFormData,
  idDelegacion,
  tipoProfesionalesMap,
  setFuncionCuidadorId,
  puedeEstarActivo,
  desactivadoAMano,
  idProfesional,
  setDesactivadoAMano,
  datosProfesionalInicial,
  reiniciarMatriculas
}) => {
  const [documentosOptions, setDocumentosOptions] = useState([]);
  const [especialidadesOptions, setEspecialidadesOptions] = useState([]);
  const [funcionesOptions, setFuncionesOptions] = useState([]);
  const [esMedico, setEsMedico] = useState(false);
  const [esEnfermero, setEsEnfermero] = useState(false);
  const idTipoDocumentoDNI = 27; // ID fijo para DNI

  const handleChange = (name, value) => {
    if (name === 'activo') {
      if (value === true) {
        if (!puedeEstarActivo(true, true)) {
          setDatosGeneralesFormData((prevData) => ({
            ...prevData,
            [name]: false
          }));
          return;
        }
      } else if (value === false) {
        setDesactivadoAMano(true);
      }
    }
    if (name === 'idTipoProfesional') {
      reiniciarMatriculas();
    }
    setDatosGeneralesFormData((prevData) => ({
      ...prevData,
      [name]: value
    }));
  };

  // Queries
  const { data: dataTipoDocumento, loading: tipoDocumentoLoading } = useQuery(GET_ALL_TIPO_DOCUMENTO);
  const { data: dataTipoEspecialidad, loading: especialidadesLoading } = useQuery(GET_ALL_TIPO_PROFESIONAL_ESPECIALIDAD);
  const { data: dataFunciones, loading: funcionesLoading } = useQuery(GET_FUNCIONES);

  const [getDocumentoProfesional, { data: documentoProfesional }] = useLazyQuery(GET_DOCUMENTO_PROFESIONAL, {
    fetchPolicy: 'network-only'
  });

  // Mutations
  const [addDocumentoProfesional, { loading: addingDocumento }] = useMutation(ADD_DOCUMENTO_PROFESIONAL);
  const [deleteDocumentosProfesional, { loading: deletingDocumento }] = useMutation(DELETE_DOCUMENTOS_PROFESIONAL);

  const handleChangeArchivo = async (name, value) => {
    const image = await obtenerDataImagen(value);

    try {
      const { data } = await addDocumentoProfesional({
        variables: {
          input: {
            archivo: image?.data,
            contentType: image?.tipo,
            titulo: image?.nombre,
            extension: image?.extension
          },
          idProfesional: datosGeneralesFormData.id,
          idTipoDocumento: idTipoDocumentoDNI
        }
      });

      if (data?.addDocumentoProfesional?.success) {
        toast.success('Documento adjuntado correctamente');
        getDocumentoProfesional({ variables: { idProfesional: datosGeneralesFormData.id } });
      }
    } catch (error) {
      toast.error('Error al adjuntar documento');
      console.error('Error al subir documento:', error);
    }
  };

  const handleDeleteArchivo = async (name) => {
    try {
      const { data } = await deleteDocumentosProfesional({
        variables: {
          idTipoDocumento: idTipoDocumentoDNI,
          idProfesional: datosGeneralesFormData.id
        }
      });

      if (data?.deleteDocumentosProfesional?.success) {
        toast.success('Documento eliminado correctamente');
        setDatosGeneralesFormData((prev) => ({
          ...prev,
          [name]: null
        }));
      }
    } catch (error) {
      toast.error('Error al eliminar documento');
      console.error('Error al eliminar documento:', error);
    }
  };

  // Effects
  useEffect(() => {
    if (!dataTipoDocumento) return;
    setDocumentosOptions(adaptTipoDocumentoArray(dataTipoDocumento));
  }, [dataTipoDocumento]);

  useEffect(() => {
    if (!idProfesional) return;
    getDocumentoProfesional({ variables: { idProfesional } });
  }, [idProfesional]);

  useEffect(() => {
    if (!documentoProfesional) return;
    setDatosGeneralesFormData((prevData) => ({
      ...prevData,
      documento: documentoProfesional?.documentoProfesionalAdjunto
    }));
  }, [documentoProfesional]);

  useEffect(() => {
    if (!dataTipoEspecialidad) return;
    setEspecialidadesOptions(adaptAllTipoProfesionalEspecialidadArray(dataTipoEspecialidad));
  }, [dataTipoEspecialidad]);

  useEffect(() => {
    if (!dataFunciones) return;
    const funciones = adaptFuncionesArray(dataFunciones?.funcionesProfesional);
    setFuncionCuidadorId(funciones.find((x) => x.displayName?.toLowerCase()?.includes('cuidador'))?.id);
    setFuncionesOptions(funciones);
  }, [dataFunciones]);

  useEffect(() => {
    if (isNew && documentosOptions?.length > 0) {
      const valueDefault = documentosOptions.find((x) => x.displayName === 'DNI')?.id;
      handleChange('idTipoDocumento', valueDefault);
      handleChange('fidelizado', false);
      handleChange('ejerceFonoaudiologo', false);
      handleChange('ejerceKinesiologo', false);
    }
  }, [documentosOptions, isNew, tipoDocumentoLoading]);

  useEffect(() => {
    if (datosGeneralesFormData?.idTipoProfesional) {
      const tipoProfesional = tipoProfesionales.find((x) => x.id == datosGeneralesFormData?.idTipoProfesional);
      setEsMedico(tipoProfesional?.displayName === 'Medico');
      setEsEnfermero(tipoProfesional?.displayName === 'Enfermero');

      if (tipoProfesional?.displayName !== 'Medico')
        handleChange('idEspecialidad', null);

      if (tipoProfesional?.displayName !== 'Enfermero')
        handleChange('idFuncion', null);
    }
  }, [datosGeneralesFormData?.idTipoProfesional]);

  const updatedFields = useMemo(() => {
    return structuredClone(fields).map((input) => {
      const updatedInput = { ...input };
      switch (input.name) {
        case 'documento':
          updatedInput.disabled = !datosGeneralesFormData?.id || addingDocumento || deletingDocumento;
          updatedInput.disabledLabel = !datosGeneralesFormData?.id
            ? 'Guarde el profesional primero para adjuntar el documento.'
            : null;
          break;
        case 'numeroDoc':
          updatedInput.disabled = !isNew && !!datosProfesionalInicial?.datosGenerales?.numeroDoc;
          break;
        case 'idTipoProfesional':
          updatedInput.options = tipoProfesionales;
          updatedInput.disabled = !isNew;
          break;
        case 'idFuncion':
          updatedInput.options = funcionesOptions;
          updatedInput.disabled = !isNew && !!datosProfesionalInicial?.datosGenerales?.idFuncion || !datosGeneralesFormData.idTipoProfesional || !esEnfermero;
          break;
        case 'idTipoDocumento':
          updatedInput.options = documentosOptions;
          break;
        case 'idEspecialidad':
          updatedInput.options = especialidadesOptions;
          updatedInput.disabled = !isNew && !!datosProfesionalInicial?.datosGenerales?.idEspecialidad || !datosGeneralesFormData.idTipoProfesional || !esMedico;
          break;
        case 'cuitL':
          updatedInput.disabled = !isNew && !!datosProfesionalInicial?.datosGenerales?.cuitL;
          break;
        case 'ejerceFonoaudiologo':
          updatedInput.hidden = datosGeneralesFormData?.idTipoProfesional !== tipoProfesionalesMap?.KINESIOLOGO;
          break;
        case 'ejerceKinesiologo':
          updatedInput.hidden = datosGeneralesFormData?.idTipoProfesional !== tipoProfesionalesMap?.TERAPISTA_OCUPACIONAL && datosGeneralesFormData?.idTipoProfesional !== tipoProfesionalesMap?.REHABILITADOR;
          break;
        default:
          break;
      }
      if (!allowedWrite) {
        updatedInput.disabled = true;
      }
      return updatedInput;
    });
  }, [
    tipoProfesionales,
    tipoProfesionalesMap,
    isNew,
    esMedico,
    esEnfermero,
    allowedWrite,
    funcionesOptions,
    especialidadesOptions,
    documentosOptions,
    datosGeneralesFormData?.documento,
    datosGeneralesFormData?.id,
    datosGeneralesFormData?.idTipoProfesional,
    datosProfesionalInicial?.datosGenerales?.numeroDoc,
    datosProfesionalInicial?.datosGenerales?.cuitL,
    datosProfesionalInicial?.datosGenerales?.idEspecialidad,
    datosProfesionalInicial?.datosGenerales?.idFuncion,
    addingDocumento,
    deletingDocumento
  ]);

  const loadingPage = useMemo(() => {
    return profesionalLoading || tipoDocumentoLoading || especialidadesLoading || funcionesLoading;
  }, [profesionalLoading, tipoDocumentoLoading, especialidadesLoading, funcionesLoading]);

  if (loadingPage) return (
    <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '20vh' }}>
      <CircularProgress size={40} />
    </Box>
  );

  return (
    <div className='generic-tab-container'>
      <Grid container spacing={3}>
        {updatedFields
          .filter((input) => !input.hidden)
          .map((input, index) => (
            <Grid
              key={`input-${input.name}-index-${index}`}
              size={{ md: input.col, xs: input.type !== 'item' ? 12 : 0 }}
            >
              {input.name !== 'cod_Proveedor' && (
                <RenderInputByTypeMobile
                  key={`input-${input.name}-index-${index}${['activo', 'cuitSAP'].includes(input.name) ? datosGeneralesFormData[input.name] : ''}`}
                  input={input}
                  handleChange={input.type === 'file' ? handleChangeArchivo : handleChange}
                  handleDelete={input.type === 'file' ? handleDeleteArchivo : null}
                  value={datosGeneralesFormData[input.name]}
                />
              )}
              {input.name === 'cod_Proveedor' && (
                <ProveedoresSapField
                  key={`input-${input.name}-index-${index}-value-${datosGeneralesFormData[input.name]}`}
                  handleChange={handleChange}
                  disabled={!allowedWrite || (!isNew && !!datosGeneralesFormData?.cod_Proveedor)}
                  idDelegacion={idDelegacion}
                  datosGeneralesFormData={datosGeneralesFormData}
                />
              )}
            </Grid>
          ))}
      </Grid>
    </div>
  );
};

const fields = [
  {
    displayName: 'Tipo profesional',
    name: 'idTipoProfesional',
    type: 'select',
    disabled: false,
    col: 2.5
  },
  {
    displayName: 'Funcion',
    name: 'idFuncion',
    type: 'select',
    disabled: false,
    col: 2
  },
  {
    displayName: 'Especialidad',
    name: 'idEspecialidad',
    type: 'select',
    disabled: false,
    col: 2.5
  },
  {
    displayName: 'Cod. Profesional',
    name: 'codProfesional',
    type: 'int',
    disabled: true,
    col: 2
  },
  {
    displayName: 'Activo',
    name: 'activo',
    type: 'custom_switch',
    disabled: false,
    col: 2
  },
  {
    name: 'item',
    type: 'item',
    col: 1
  },
  {
    displayName: 'Nombre',
    name: 'nombre',
    type: 'string',
    disabled: false,
    col: 3
  },
  {
    displayName: 'Apellido',
    name: 'apellido',
    type: 'string',
    disabled: false,
    col: 3
  },
  {
    displayName: 'Tipo Docu.',
    name: 'idTipoDocumento',
    type: 'select',
    disabled: true,
    col: 2
  },
  {
    displayName: 'Número Doc.',
    name: 'numeroDoc',
    type: 'string',
    disabled: false,
    col: 3
  },
  {
    name: 'item',
    type: 'item',
    col: 1
  },
  {
    displayName: 'Adjuntar DNI',
    name: 'documento',
    type: 'file',
    disabled: true,
    col: 6
  },
  {
    name: 'item',
    type: 'item',
    col: 6
  },
  {
    displayName: 'C.U.I.T/L',
    name: 'cuitL',
    type: 'int',
    disabled: false,
    col: 2
  },
  {
    displayName: 'C.U.I.T.SAP',
    name: 'cuitSAP',
    type: 'int',
    disabled: true,
    col: 2
  },
  {
    displayName: 'Sexo',
    name: 'sexo',
    type: 'select',
    options: [
      { id: 'F', displayName: 'Femenino' },
      { id: 'M', displayName: 'Masculino' }],

    disabled: false,
    col: 2
  },
  {
    displayName: 'F.Nacimiento',
    name: 'fechaNacimiento',
    type: 'date',
    disabled: false,
    col: 3
  },
  {
    name: 'item',
    type: 'item',
    col: 3
  },
  {
    displayName: 'Email',
    name: 'email',
    type: 'string',
    disabled: false,
    col: 3
  },
  {
    displayName: 'Codigo SAP',
    name: 'cod_Proveedor',
    type: 'search',
    disabled: false,
    col: 3
  },
  {
    displayName: 'Fidelizado',
    name: 'fidelizado',
    type: 'check',
    disabled: false,
    col: 3
  },
  {
    displayName: 'Observacion',
    name: 'observacion',
    type: 'long_string',
    disabled: false,
    col: 12
  },

  {
    displayName: 'Puede ejercer como Fonoaudiólogo',
    name: 'ejerceFonoaudiologo',
    type: 'check',
    disabled: false,
    col: 7
  },
  {
    displayName: 'Puede ejercer como Kinesiólogo',
    name: 'ejerceKinesiologo',
    type: 'check',
    disabled: false,
    col: 7
  }];